
export enum ResearchStatus {
  Active = 0,
  Archived = 1
}
